import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowRightLeft,
  Package,
  TrainFront,
  AlertTriangle,
  Pencil,
  ScanLine,
  LogOut,
  Cpu,
  CircleDot,
} from "lucide-react";
import { formatEventMessage, formatEventSource, localeFor } from "../i18n";

const ICONS = {
  move: ArrowRightLeft,
  load: Package,
  arrive: TrainFront,
  transfer: TrainFront,
  depart: LogOut,
  alert: AlertTriangle,
  edit: Pencil,
  ocr: ScanLine,
  system: Cpu,
  intake: TrainFront,
};

const SEV_COLOR = {
  info: "#38bdf8",
  success: "#10b981",
  warning: "#f59e0b",
  critical: "#f43f5e",
};

export const EventJournal = ({ events, lang, t }) => {
  return (
    <div className="overflow-y-auto no-scrollbar p-2" data-testid="event-journal">
      <AnimatePresence initial={false}>
        {(events || []).map((e) => {
          const Icon = ICONS[e.type] || CircleDot;
          const color = SEV_COLOR[e.severity] || "#38bdf8";
          const msg = formatEventMessage(e, t, lang);
          const time = new Date(e.ts).toLocaleTimeString(localeFor(lang));
          const source = formatEventSource(e.sourceKey, t);
          return (
            <motion.div
              key={e.id}
              layout
              initial={{ opacity: 0, x: 12 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0 }}
              className="flex gap-2.5 px-2 py-2 border-l-2 hover:bg-zinc-900/50 rounded-r-sm"
              style={{ borderColor: color }}
              data-testid={`event-${e.type}`}
            >
              <Icon size={14} style={{ color }} className="mt-0.5 shrink-0" />
              <div className="min-w-0">
                <p className="text-[11.5px] text-zinc-300 leading-snug">{msg}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-[9px] font-mono text-zinc-600">{time}</span>
                  <span className="text-[9px] font-mono uppercase tracking-wider text-zinc-600">
                    · {source}
                  </span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
